import { render, staticRenderFns } from "./Upgrading.vue?vue&type=template&id=0888fe1f&"
import script from "./Upgrading.vue?vue&type=script&lang=js&"
export * from "./Upgrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports